import { render, staticRenderFns } from "./contact-module.vue?vue&type=template&id=41b52c62&scoped=true"
import script from "./contact-module.vue?vue&type=script&lang=js"
export * from "./contact-module.vue?vue&type=script&lang=js"
import style0 from "./contact-module.vue?vue&type=style&index=0&id=41b52c62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b52c62",
  null
  
)

export default component.exports